import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Celsius from "../axes/Celsius";

let Asparagus3 = {
    type: "line",
    label: "Temperature 3",
    fill: false,
    lineTension: 0,
    colorPalette: 16,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Celsius,
    xAxis:Time
};

export default Asparagus3;



// WEBPACK FOOTER //
// ./src/components/chart/channels/Asparagus3.js